import { Component, Optional } from '@angular/core';
import {
  FQAN_jedgrad_id,
  TYPE_jedinica_gradiva
} from '@app/components/hierarhija/hierarhija.component';
import {
  ItemActionResult,
  ItemProvider,
  ListView,
  ListViewProviderDirective,
  NotificationService,
  NtapGlobalConstants,
  ViewWindow,
  WindowRegistry
} from '@ntap/core';
import { map, Observable } from 'rxjs';
import { DokumentacijaOpenItemViewActionComponent } from './openitemview-dokumentacija';
import {
  DokItemInfo,
  DokType
} from '@app/components/dokumentacija/dokumentacija-types';

@Component({
  selector: 'app-new-folder-action',
  templateUrl: './primeng-button-template.html'
})
export class NewFolderActionComponent extends DokumentacijaOpenItemViewActionComponent {
  constructor(
    protected override notificationService: NotificationService,
    protected override windowRegistry: WindowRegistry,
    @Optional() protected override window: ViewWindow,
    @Optional() protected override itemProvider: ItemProvider,
    protected listViewProvider: ListViewProviderDirective<ListView>
  ) {
    super(notificationService, windowRegistry, window, itemProvider);
  }

  protected override isDisabled(dokInfo: DokItemInfo): boolean {
    return dokInfo.permission < 2 || dokInfo.dokType != DokType.FOLDER;
  }
  protected override doExecuteWithItem(
    item: any
  ): Observable<ItemActionResult> {
    const itemId = item[FQAN_jedgrad_id];
    let finalItem;
    if (!itemId || itemId == 0) {
      finalItem = item;
    } else {
      finalItem = Object.assign({}, item);
      finalItem[NtapGlobalConstants.ATTR_$parentType] = TYPE_jedinica_gradiva;
      finalItem[NtapGlobalConstants.ATTR_$parentId] = item[FQAN_jedgrad_id];
      finalItem[FQAN_jedgrad_id] = 0;
    }
    return super.doExecuteWithItem(finalItem).pipe(
      map((iar) => new ItemActionResult(iar.result, item))
      // tap(a => this.listViewProvider.refresh())
    );
  }
}
